import Kiln from '@/models/Kiln'
import User, { hasRole, Role } from '@/models/User'

export default class KilnPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, kiln: Kiln) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === kiln.entry.catalog.company.id
			case Role.AUDITOR:
				return kiln.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, kiln: Kiln) {
		return hasRole(user, Role.USER) && user.company?.id === kiln.entry.catalog.company.id
	}

	restore(user: User, kiln: Kiln) {
		return hasRole(user, Role.USER) && user.company?.id === kiln.entry.catalog.company.id
	}

	delete(user: User, kiln: Kiln) {
		return hasRole(user, Role.USER) && user.company?.id === kiln.entry.catalog.company.id
	}

	forceDelete(_user: User, _kiln: Kiln) {
		return false
	}
}
